import { render } from "./ViewAsset.vue?vue&type=template&id=21dde7fc&scoped=true"
import script from "./ViewAsset.vue?vue&type=script&lang=js"
export * from "./ViewAsset.vue?vue&type=script&lang=js"

import "./ViewAsset.vue?vue&type=style&index=0&id=21dde7fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abola\\Documents\\A.Personal Dev\\CHI\\assetmentainance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dde7fc"]])

export default __exports__